export const cilExpandRight = ["24 24","<path d='M1.875 0.891h1.5v22.5h-1.5v-22.5z'></path><path d='M18.375 0.891v22.5h6v-22.5zM22.875 21.891h-3v-19.5h3z'></path><path d='M5.625 4.641v15h1.775l7.939-7.496-7.842-7.504zM7.125 17.837v-11.476l6.036 5.776z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-expand-right.js
// module id = null
// module chunks = 